module.exports = __webpack_public_path__ + "static/media/Dev_logo.8382454c.png";